import { HttpContextToken } from '@angular/common/http';

export const IS_AUTHENTICATED = new HttpContextToken<boolean>(() => true);
export const SET_TENANT_DEFAULT = new HttpContextToken<boolean>(() => true);
